export const environment = {
  production: false,
  apiUrl: 'https://devapp.contechpro.ai',
  adminApiUrl: 'https://devapp.contechpro.ai',
  appName: 'TALOS',
  appVersion: '1.0.0',
  encryptionSecret: 'hX2wAklzpq4PSQZaSgvPDbxYwHqJKT9kMXPO9v6mIFk',
  routeParamSecret: 'NRKc6XxmLwb0FM1oFX4trgIerAmlP2lfSCaRVarLA8s',
};
